<template>
  <div>
    <v-select
      :items="items"
      color="primaryText"
      :prepend-inner-icon="prependIcon"
      :label="label"
      v-model="model"
      @change="changeHandler"
      :item-text="itemText"
      :item-value="itemValue"
      :return-object="returnObject"
      hide-details
      hide-selected
      outline
      :background-color="$vuetify.theme.bg"
      offset-y
      class="unq-mb-font"
    >
    <template v-slot:item="{ item }">
      <div class="unq-select-item">
        {{ item[`${itemText ? itemText : 'text'}`] }}
      </div>
    </template>
    </v-select>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    selection: Number | String,
    label: String,
    itemText: String,
    itemValue: String,
    returnObject: {
      type: Boolean,
      default: false,
    },
    width: Number | String,
    prependIcon: String,
  },
  data() {
    return {
      model: null,
    };
  },
  mounted() {
    this.selectionHandler();
  },
  methods: {
    selectionHandler() {
      if (!isNaN(this.selection)) {
        const index = +this.selection;
        this.model = this.items[index];
      } else {
        this.model = this.selection;
      }
    },
    changeHandler() {
      this.$emit("change", this.model);
    },
  },
  watch: {
    selection() {
      this.selectionHandler();
    },
  },
};
</script>

<style>
@media (max-width: 960px) {
  .unq-mb-font {
    font-size: 12px !important;
  }

  .unq-select-item {
    height: 27px;
    color: var(--v-primary-text);
    font-size: 12px !important;
  }
  
  .v-list__tile:has(.unq-select-item) {
    height: 32px;
  }
}
</style>
